// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__2P-3t","text":"styles_text__4E4WX","value":"styles_value__2ewA7"};